import TextLink from "../../TextLink";
import React from 'react';
import { Link } from 'react-router-dom';
import { isUrlExternal } from "../../../utils";
var LinkRenderer = function (_a) {
    var href = _a.href, title = _a.title, children = _a.children, onClick = _a.onClick;
    var blank = href.endsWith(':_blank');
    if (onClick) {
        return React.createElement(TextLink, { onClick: onClick }, children);
    }
    return !isUrlExternal(href) && !blank ? (React.createElement(Link, { to: href, title: title }, children)) : (React.createElement(TextLink, { href: href.replace(':_blank', ''), target: blank ? '_blank' : undefined, title: title }, children));
};
export default LinkRenderer;
//# sourceMappingURL=LinkRenderer.js.map